import { mountReactComponents } from "../react";
//
var document_ready, endaWidth, vhFix;

const autoresizer = () => {
  return $("textarea.autoresize").removeClass("autoresize").autosize();
};

document_ready = function () {
  mountReactComponents();

  vhFix();
  endaWidth();
  $(window).resize(function () {
    vhFix();
    return endaWidth();
  });
  key("esc", function () {
    return $(".key-esc").click();
  });
  key("left", function () {
    return $(".key-left").click();
  });
  key("right", function () {
    return $(".key-right").click();
  });
  $(".toggler").on("click", function (e) {
    var $this;
    e.preventDefault();
    $this = $(this);
    $this.toggleClass("active");
    $this.toggleClass("" + $this.data("toggle-self"));
    return $("" + $this.data("toggle-target")).toggleClass(
      "" + $this.data("toggle-class")
    );
  });
  autoresizer();
  // $(".fitvid").fitVids();
  $(".sortable-list").sortable({
    items: "li.sort",
    handle: ".handle",
    update: function () {
      return $.post($(this).data("update-url"), $(this).sortable("serialize"));
    },
  });
  $(".sortable-form").sortable({
    items: ".sort",
    axis: "y",
    handle: ".handle",
    stop: function () {
      var inputs;
      inputs = void 0;
      inputs = $("input.position");
      return $("input.position").each(function (i) {
        $(this).val(i);
      });
    },
  });
  $(".autohide").delay(5000).fadeOut();
  $(".autohide").on("click", function (e) {
    e.preventDefault();
    return $(this).hide();
  });
  $("form").on("click", ".add_fields", function (event) {
    var regexp, time;
    event.preventDefault();
    time = new Date().getTime();
    regexp = new RegExp($(this).data("id"), "g");
    $(this).before($(this).data("fields").replace(regexp, time));
    autoresizer();
    return mountReactComponents();
  });
  $("form").on("click", ".remove_fields", function (event) {
    event.preventDefault();
    if ($(this).prev("input[type=hidden]").val() === "0") {
      $(this).html("Cancel");
      $(this).prev("input[type=hidden]").val("1");
      return $(this).closest("fieldset").fadeTo(200, 0.2);
    } else {
      $(this).html("Remove");
      $(this).prev("input[type=hidden]").val("0");
      return $(this).closest("fieldset").fadeTo(200, 1);
    }
  });
  return $("#cookie_accept .close").on("click", function (e) {
    e.preventDefault();
    $.cookie("cookies_accepted", true);
    return $("#cookie_accept").hide();
  });
};

vhFix = function () {
  $(".vh-100-max").css("max-height", $(window).height() - 16);
  $(".vh-100-min").css("min-height", $(window).height());
  $(".vh-100").css("height", $(window).height());
  return $(".vh-50").css("height", $(window).height() / 2);
};

endaWidth = function () {
  var w;
  w = (($(window).height() - 125 - 16) / 4) * 5 + 16;
  if (w > 600) {
    return $(".enda-width").css("max-width", w + "px");
  }
};

$(document).ready(document_ready);

$(document).on("page:load", document_ready);

// ---
// generated by coffee-script 1.9.2
